/* eslint-disable no-undef */

function getMapWithFallback(key, mapName) {
  //This function can handle if mapName is a map or string (1st fallback), and if mapName is a map and the key is not
  //found in the map, uses the DEFAULT value (2nd fallback)
  if (key.startsWith(mapName)) {
    const groupVal = getValueFromWindowObjectOrEnvFile(mapName);
    try {
      const map = new Map(JSON.parse(groupVal));
      const subkey = key.replace(mapName + "_", "");
      if (key === mapName) {
        return map.get("DEFAULT");
      } else if (map.has(subkey)) {
        return map.get(subkey);
      } else {
        return map.get("DEFAULT");
      }
    } catch (e) {
      console.log(e);
      return groupVal;
    }
  } //else return undefined
}

function getValueFromWindowObjectOrEnvFile(key) {
  return window[key] === undefined || window[key] === "DOCKER_ENV_" + key
    ? process.env[key] // If the value haven't changed from the default, use .env.* file instead
    : window[key];
}

function getEnvValue(key) {
  const chatGroupValue = getMapWithFallback(
    key,
    "VUE_APP_SALESFORCE_CHAT_GROUP"
  );
  if (chatGroupValue) {
    return chatGroupValue;
  }

  const chatBtnValue = getMapWithFallback(key, "VUE_APP_SALESFORCE_CHAT_BTN");
  if (chatBtnValue) {
    return chatBtnValue;
  }

  const returnValue = getValueFromWindowObjectOrEnvFile(key);
  if (returnValue) {
    return returnValue;
  }
  throw new Error(`${key} is not a valid environment value key.`);
}

const envConfiguration = {
  recaptchaApikey: getEnvValue("VUE_APP_reCAPTCHA_APIKEY"),
  googleMapApikey: getEnvValue("VUE_APP_GOOGLEMAP_APIKEY"),
  pendoApiKey: getEnvValue("VUE_APP_PENDO_APIKEY"),
  salesforceStorageDomain: getEnvValue("VUE_APP_SALESFORCE_CHAT_STORAGEDOMAIN"),
  salesforcePtUrl: getEnvValue("VUE_APP_SALESFORCE_PT_URL"),
  vpUrl: getEnvValue("VUE_APP_VP_URL"),
  salesforceId: getEnvValue("VUE_APP_SALESFORCE_ID"),
  salesforceChatGroup: getEnvValue("VUE_APP_SALESFORCE_CHAT_GROUP"),
  salesforceChatGroupPurl: getEnvValue("VUE_APP_SALESFORCE_CHAT_GROUP_PURL"),
  salesforceChatBtn: getEnvValue("VUE_APP_SALESFORCE_CHAT_BTN"),
  salesforceChatBtnPurl: getEnvValue("VUE_APP_SALESFORCE_CHAT_BTN_PURL"),
  salesforceBaseLiveAgentContentUrl: getEnvValue(
    "VUE_APP_SALESFORCE_BASE_LIVE_AGENT_CONTENT_URL"
  ),
  salesforceDeploymentId: getEnvValue("VUE_APP_SALESFORCE_DEPLOYMENT_ID"),
  salesforceLiveAgentUrl: getEnvValue("VUE_APP_SALESFORCE_BASE_LIVE_AGENT_URL"),
  salesforceEswUrl: getEnvValue("VUE_APP_SALESFORCE_ESW_URL")
};

export default envConfiguration;
